// extracted by mini-css-extract-plugin
export default {"icon":"style-module--icon--91fa9","gray":"style-module--gray--0f5e7"};